import { render, staticRenderFns } from "./my-footer.vue?vue&type=template&id=9d9b86a0&scoped=true&"
var script = {}
import style0 from "./my-footer.vue?vue&type=style&index=0&id=9d9b86a0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d9b86a0",
  null
  
)

export default component.exports